/**
 * @file Consultation service API — CRUD for a professional's offered services
 *       (e.g. "Consulta general", "Consulta de seguimiento").
 *
 * All endpoints are scoped to the authenticated professional via `/professional/me`.
 *
 * @module services/consultationService
 */
import api from "./api";

/**
 * Consultation-service CRUD methods.
 * @type {Object}
 */
export const consultationServiceApi = {
  /** @returns {Promise<Object[]>} All services for the current professional. */
  getAll: () => api.get("/professional/me/services"),
  /** @param {{ name: string, price?: number }} data */
  create: (data) => api.post("/professional/me/services", data),
  /** @param {string} id  @param {{ name?: string, price?: number }} data */
  update: (id, data) => api.put(`/professional/me/services/${id}`, data),
  /** @param {string} id */
  remove: (id) => api.delete(`/professional/me/services/${id}`),
};
